// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_3fupY4vsJKLDMnRRuis1GW"};